import React, { FC, useCallback, MouseEvent } from "react";
import { getApiUrl } from "utils/getApiUrl";

import { BasicIntegrationCard, IntegrationCardProp } from "./BasicIntegrationCard";

export const JobberIntegrationCard: FC<IntegrationCardProp> = (props) => {

    const { checked, appId, disabled, isLinked, isActive, onDisconnect } = props;

    const generateOAUTHClick = useCallback((url: string) => {
        return (e: MouseEvent<HTMLAnchorElement>): boolean => {

            if (url && !disabled) {
                window.open(url, "callout-option", "toolbar=0,status=0,width=1000,height=700");
            }
            // prevent default so the original href doesn't open
            e.preventDefault();
            return false;
        }
    }, [disabled]);

    const generateJobberLink = useCallback(() => {
        const clientId = window?.xaStudioConfig?.integrations?.jobber?.clientId;
        return `https://api.getjobber.com/api/oauth/authorize?response_type=code&client_id=${clientId}&state=${appId}&redirect_uri=${getApiUrl()}/integration/jobber`
    }, [appId]);


    const handleDisconnectJobber = useCallback(() => {
        if (typeof onDisconnect === "function") {
            onDisconnect();
        }
    }, [onDisconnect]);

    const handleJobberClick = useCallback((e: MouseEvent<HTMLAnchorElement>) => {
        e.preventDefault();

        if (typeof props.onClick === "function") {
            props.onClick(e);
        }

    }, [props]);

    return (
        <BasicIntegrationCard
            checked={checked}
            disabled={disabled}
            imageUrl="/img/integrations/jobber/jobber-logo.png"
            text="Jobber"
            href={generateJobberLink}
            onClick={typeof checked === "boolean" ? handleJobberClick : generateOAUTHClick(generateJobberLink())}
            isLinked={isLinked}
            isActive={isActive}
            onDisconnect={typeof onDisconnect === "function" ? handleDisconnectJobber : undefined}
        />
    );
}